import React from 'react';
import SelectField from '../../Select';
// Local Deps
import msgs from '../../../config/messages';

export const configureInfoDetails = EntityDetailprops => {
  const {
    cageCode,
    entityName,

    address1,
    address2,
    address3,
    city,
    state,
    zipCode,
    cntry,
    materialCastings,
    castingProcess,
  } = EntityDetailprops;

  return [
    {
      left: msgs.OrganizationForm.cageCode,
      right: cageCode,
    },
    {
      left: msgs.OrganizationForm.organizationName,
      right: entityName,
    },

    {
      left: msgs.OrganizationForm.address1,
      right: address1,
    },
    {
      left: msgs.OrganizationForm.address2,
      right: address2,
    },
    {
      left: msgs.OrganizationForm.address3,
      right: address3,
    },
    {
      left: msgs.OrganizationForm.city,
      right: city,
    },
    {
      left: msgs.OrganizationForm.stateZip,
      right: `${state}, ${zipCode}`,
    },
    {
      left: 'Country',
      right: cntry,
    },
    {
      left: msgs.OrganizationForm.materialCastings,
      right: materialCastings,
    },
    {
      left: msgs.OrganizationForm.castingProcess,
      right: castingProcess,
    },
  ];
};

export const configureAccessTable = EntityDetailprops => {
  const { masterAccess } = EntityDetailprops; //eslint-disable-line
  const Options = [
    { text: 'Approved', valuee: 'approved' },
    { text: 'Denied', value: 'denied' },
    { text: 'Pending', value: 'pending' },
  ];

  return [
    {
      left: msgs.ViewDetailsModal.orgIconStatus,
      right: <SelectField options={Options} />,
    },
    {
      left: msgs.ViewDetailsModal.orgType,
      right: <SelectField options={Options} />,
    },
  ];
};



// WEBPACK FOOTER //
// ./src/components/Modals/ManagePendingRequest/detailsTableConfig.jsx